// src/constants/roles.js

export const FINANCE_ROLE_ID = ['28'];
export const FINANCE_MANAGER_ROLE_ID = ['5','27'];
export const AUDIT_ROLE_ID = ['55'];

export const SHOW_ROOM_MANAGER_ROLE_ID = ['43','1'];
export const CUSTOMER_CARE_MANAGER_ROLE_ID = '44';
export const CUSTOMER_CARE_SUPERVISOR_ROLE_ID = '38';
export const STORE_CUSTOMER_CARE_SUPERVISOR_ROLE_ID = '45';

export const DO_CREATE_ALLOWED_USER_ROLES = ['1', '49'];
export const DO_CLOSED_ALLOWED_USER_ROLES = ['50'];
